var exports = {
  "kL": "container__af3WNs",
  "KY": "actionBar__CwtaXk",
  "RT": "menuKeybindingHint__9shyRP",
  "H3": "menuLeadingVisualPlaceholder__kTM53G",
};

module.exports = exports;
